module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loginAs":"Choose user to login as","noUsersFound":"No users found"}}')
  delete Component.options._Ctor
}
